module.exports = __webpack_public_path__ + "img/ulta_logo.2689cb84.svg";